import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './core/components/toast-container.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, ToastContainerComponent],
    templateUrl: './app.html',
})
export class App {}
